import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ENVIRONMENT } from '@env/environment';
import { User } from '@stores/models/user/user';

@Injectable()
export class UserService {
  readonly #httpClient = inject(HttpClient);

  readonly #coreApiUrl = ENVIRONMENT.coreApi.endpoint;

  loadUser(): Observable<User> {
    return this.#httpClient.get<User>(`${this.#coreApiUrl}/user`);
  }
}
